var React = require('react');

function CloudThin (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M37.904 19.819C36.572 13.082 30.628 8 23.5 8c-5.66 0-10.555 3.212-13.013 7.902C4.592 16.529 0 21.522 0 27.583c0 6.492 5.258 11.75 11.75 11.75h25.458c5.405 0 9.792-4.386 9.792-9.791 0-5.17-4.015-9.361-9.096-9.723zm-.696 15.598H11.75c-4.318 0-7.833-3.516-7.833-7.834s3.515-7.833 7.833-7.833 7.833 3.515 7.833 7.833H23.5c0-5.405-3.652-9.938-8.617-11.309 1.968-2.634 5.092-4.357 8.617-4.357 5.944 0 10.77 4.827 10.77 10.77v.98h2.938a5.88 5.88 0 015.875 5.875 5.88 5.88 0 01-5.875 5.875z"}));
}

CloudThin.defaultProps = {"viewBox":"0 0 48 48"};

module.exports = CloudThin;

CloudThin.default = CloudThin;
